import {HttpClient} from "../requests";
import ENDPOINTS from "../endpoints";
import { 
    AuditLogDto,
    AuditLogPaginator, 
    QueryAuditLogDto, 
    SearchAuditLogDto
} from "../../../models/audit-log.dto";

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * The audit service takes "YYYY-MM-DD HH:mm:ss" in UTC, while the table
 * filter gives local dates. Converts a date to the UTC time of the start
 * (or the last second) of that local day; other values pass through.
 */
const toAuditTimestamp = (value: string | undefined, endOfDay: boolean) => {
    const match = value ? DATE_ONLY.exec(value) : null;
    if (!match) return value || undefined;

    const [, year, month, day] = match.map(Number);
    const date = endOfDay
        ? new Date(year, month - 1, day, 23, 59, 59)
        : new Date(year, month - 1, day, 0, 0, 0);
    return date.toISOString().slice(0, 19).replace("T", " ");
};

export class Audit {
    getAuditLog = (query?: QueryAuditLogDto) => HttpClient
        .get<AuditLogPaginator>(ENDPOINTS.AUDIT.AUDIT_LOG.GET, query && {
            ...query,
            'timestamp.gte': toAuditTimestamp(query['timestamp.gte'], false),
            'timestamp.lte': toAuditTimestamp(query['timestamp.lte'], true),
        });
    getAuditLogSearch = (query?: SearchAuditLogDto) => HttpClient
        .get<AuditLogPaginator>(ENDPOINTS.AUDIT.AUDIT_LOG.SEARCH, query);
    getAuditLogById = (auditLogId: number) => HttpClient
        .get<{ data: AuditLogDto }>(ENDPOINTS.AUDIT.AUDIT_LOG.DETAIL
            .replace('{auditLogId}', String(auditLogId)));
}